import {observable} from "mobx";
import {EntityNumberGenGroup} from "invoice/domain/entityNumberGenDomain";
import mdAxios from "core/common/config/axios-config";
import {ID} from "core/metamodel/metaConstant";
import {DataObjectDto, IDomainObject} from "core/form/formUtils";

class EntityNumberGenService {

  @observable public entityGenGroupObject: EntityNumberGenGroup;

  readEntityNumberGenGroup(genGroupId: ID): Promise<EntityNumberGenGroup> {
    return mdAxios.get(`/entity-number-gen/group/${genGroupId}`)
      .then(response => new EntityNumberGenGroup(response.data));
  }

  deleteGenGroup(genGroupId: ID): Promise<any> {
    return mdAxios.delete(`/entity-number-gen/group/${genGroupId}`, {showPrettyError: true});
  }

  saveGenGroup(entityGenGroup: DataObjectDto<EntityNumberGenGroup>): Promise<IDomainObject> {
    return mdAxios.post(`/entity-number-gen/group`, entityGenGroup, {showPrettyError: true})
      .then(res => res.data);
  }

  checkIfEntityNumberGenPrefixExist(prefixConstant: string): Promise<boolean> {
    return mdAxios.get(`/entity-number-gen/exist?prefixConstant=${prefixConstant}`, {showPrettyError: true})
      .then(res => res.data);
  }

  checkSameGenNumberPossibility(prefixConstant: string, padding: number) {
    return mdAxios.get(`/entity-number-gen/generation-possibility?prefixConstant=${prefixConstant}&padding=${padding}`, {showPrettyError: true})
      .then(res => res.data)
  }
}

export default new EntityNumberGenService();



// WEBPACK FOOTER //
// ./src/invoice/service/entityNumberGenService.ts